(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eb-bubble-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousels(root) {
    (root || document).querySelectorAll('[data-carousel]').forEach(function (carousel) {
      if (carousel.dataset.init) return;
      carousel.dataset.init = 'true';

      var track = carousel.querySelector('[data-track]');
      var dots = carousel.querySelectorAll('.eb-bubble-card__dot');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');
      var slides = carousel.querySelectorAll('.eb-bubble-card__slide');

      if (!track || slides.length < 2) return;

      function getIndex() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }

      function goTo(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: clamped * track.offsetWidth, behavior: 'smooth' });
      }

      function updateDots(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', function () {
        updateDots(getIndex());
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var i = getIndex();
          goTo(i > 0 ? i - 1 : slides.length - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var i = getIndex();
          goTo(i < slides.length - 1 ? i + 1 : 0);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initCarousels(); });
  } else {
    initCarousels();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-bubble-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-track]');
      var dots = carousel.querySelectorAll('.eb-bubble-card__dot');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');
      var slides = carousel.querySelectorAll('.eb-bubble-card__slide');

      if (!track || slides.length < 2) return;

      function getIndex() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }

      function goTo(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: clamped * track.offsetWidth, behavior: 'smooth' });
      }

      function updateDots(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', function () {
        updateDots(getIndex());
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var i = getIndex();
          goTo(i > 0 ? i - 1 : slides.length - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var i = getIndex();
          goTo(i < slides.length - 1 ? i + 1 : 0);
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-bubble-featured"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFeaturedSlider() {
    document.querySelectorAll('[data-feat-track]').forEach(function (track) {
      var wrap = track.closest('.eb-featured__slider-wrap');
      if (!wrap) return;
      var prevBtn = wrap.querySelector('[data-feat-prev]');
      var nextBtn = wrap.querySelector('[data-feat-next]');

      function scrollBy(dir) {
        var card = track.querySelector('.eb-featured__card');
        if (!card) return;
        var amount = (card.offsetWidth + 12) * dir;
        track.scrollBy({ left: amount, behavior: 'smooth' });
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { scrollBy(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollBy(1); });
    });
  }

  function initCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function (carousel) {
      var track = carousel.querySelector('[data-track]');
      var dots = carousel.querySelectorAll('.eb-bubble-card__dot');
      var prevBtn = carousel.querySelector('[data-prev]');
      var nextBtn = carousel.querySelector('[data-next]');
      var slides = carousel.querySelectorAll('.eb-bubble-card__slide');

      if (!track || slides.length < 2) return;

      function getIndex() {
        return Math.round(track.scrollLeft / track.offsetWidth);
      }

      function goTo(index) {
        var clamped = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: clamped * track.offsetWidth, behavior: 'smooth' });
      }

      function updateDots(index) {
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === index);
        });
      }

      track.addEventListener('scroll', function () {
        updateDots(getIndex());
      }, { passive: true });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var i = getIndex();
          goTo(i > 0 ? i - 1 : slides.length - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          var i = getIndex();
          goTo(i < slides.length - 1 ? i + 1 : 0);
        });
      }
    });
  }

  function init() {
    initFeaturedSlider();
    initCarousels();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-hero-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  var hero = document.querySelector('[data-eb-hero]');
  if (!hero) return;

  var btn = hero.querySelector('[data-playpause]');
  var pauseIcon = btn && btn.querySelector('.eb-hero-video__pause-icon');
  var playIcon = btn && btn.querySelector('.eb-hero-video__play-icon');
  var videos = hero.querySelectorAll('[data-video]');
  var playing = true;

  function syncIcons() {
    if (pauseIcon) pauseIcon.style.display = playing ? '' : 'none';
    if (playIcon) playIcon.style.display = playing ? 'none' : '';
    if (btn) btn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
  }

  if (btn) {
    btn.addEventListener('click', function () {
      playing = !playing;
      videos.forEach(function (v) {
        if (playing) {
          v.play();
        } else {
          v.pause();
        }
      });
      syncIcons();
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-product-spotlight"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.ebpsReady) return;
    root.dataset.ebpsReady = '1';
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ebps__slide'));
    if (slides.length < 2) return;
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      slides.forEach(function (slide, n) {
        slide.classList.toggle('is-active', n === index);
        var dots = slide.querySelectorAll('.ebps__dot');
        dots.forEach(function (dot, d) {
          dot.classList.toggle('is-on', d === index);
        });
      });
    }

    root.addEventListener('click', function (e) {
      var next = e.target.closest('[data-next]');
      if (next) {
        e.preventDefault();
        show(index + 1);
        return;
      }
      var dot = e.target.closest('[data-go]');
      if (dot) {
        e.preventDefault();
        show(parseInt(dot.getAttribute('data-go'), 10));
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ebps]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eb-video-text"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ebvt-mute]').forEach(function (btn) {
    var wrap = btn.closest('.eb-video-text__media-wrap');
    var video = wrap && wrap.querySelector('[data-ebvt-video]');
    if (!video) return;
    var iconMuted = btn.querySelector('.eb-video-text__icon-muted');
    var iconSound = btn.querySelector('.eb-video-text__icon-sound');
    btn.addEventListener('click', function () {
      video.muted = !video.muted;
      if (iconMuted) iconMuted.style.display = video.muted ? '' : 'none';
      if (iconSound) iconSound.style.display = video.muted ? 'none' : '';
      btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-may2026"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-section-type="product-may2026"]');
    if (!sections.length) return;

    sections.forEach(function (section) {
      var formatter = (window.Shopify && window.Shopify.formatMoney) || null;
      var moneyFormat = (window.Shopify && window.Shopify.money_format) || null;

      function money(cents) {
        if (cents == null || isNaN(cents)) return '';
        if (formatter && moneyFormat) return formatter(cents, moneyFormat);
        return '$' + (cents / 100).toFixed(2);
      }

      // ---------- Stars ----------
      var starsEl = section.querySelector('[data-pp-stars]');
      if (starsEl) {
        var rating = parseFloat(starsEl.getAttribute('data-pp-stars')) || 0;
        var html = '';
        for (var i = 0; i < 5; i++) {
          var fill = Math.max(0, Math.min(1, rating - i)) * 100;
          var gid = 'ppg-' + section.dataset.sectionId + '-' + i;
          html += '<svg viewBox="0 0 24 24" aria-hidden="true">'
            + '<defs><linearGradient id="' + gid + '" x1="0" x2="1" y1="0" y2="0">'
            + '<stop offset="' + fill + '%" stop-color="currentColor"/>'
            + '<stop offset="' + fill + '%" stop-color="rgba(16,16,16,0.20)"/>'
            + '</linearGradient></defs>'
            + '<path d="M12 2.5l2.95 6.36 6.9.74-5.18 4.78 1.5 6.79L12 17.77l-6.17 3.4 1.5-6.79L2.15 9.6l6.9-.74L12 2.5z" fill="url(#' + gid + ')"/>'
            + '</svg>';
        }
        starsEl.innerHTML = html;
      }

      // ---------- Gallery ----------
      var slides = section.querySelectorAll('[data-pp-slide]');
      var thumbs = section.querySelectorAll('[data-pp-thumb]');
      var dots = section.querySelectorAll('[data-pp-pagination] span');
      var prev = section.querySelector('[data-pp-prev]');
      var next = section.querySelector('[data-pp-next]');
      var current = 0;

      function setSlide(n) {
        if (!slides.length) return;
        current = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === current); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === current); });
      }

      if (prev) prev.addEventListener('click', function () { setSlide(current - 1); });
      if (next) next.addEventListener('click', function () { setSlide(current + 1); });
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { setSlide(parseInt(t.getAttribute('data-pp-thumb'), 10)); });
      });

      // ---------- Thumbnail scrollbar indicator ----------
      var thumbStrip = section.querySelector('[data-pp-thumbs]');
      var scrollbar = section.querySelector('[data-pp-scrollbar]');
      var scrollbarBar = section.querySelector('[data-pp-scrollbar-bar]');
      if (thumbStrip && scrollbar && scrollbarBar) {
        var rafId = null;
        function syncScrollbar() {
          rafId = null;
          var scrollWidth = thumbStrip.scrollWidth;
          var clientWidth = thumbStrip.clientWidth;
          if (scrollWidth <= clientWidth + 1) {
            scrollbar.classList.remove('is-active');
            return;
          }
          scrollbar.classList.add('is-active');
          var ratio = clientWidth / scrollWidth;
          var maxScroll = scrollWidth - clientWidth;
          var pos = maxScroll > 0 ? thumbStrip.scrollLeft / maxScroll : 0;
          var barWidth = Math.max(12, ratio * 100);
          var trackWidth = scrollbar.clientWidth;
          var barPx = (barWidth / 100) * trackWidth;
          var maxTranslate = trackWidth - barPx;
          scrollbarBar.style.width = barWidth + '%';
          scrollbarBar.style.transform = 'translateX(' + (pos * maxTranslate) + 'px)';
        }
        function scheduleSync() {
          if (rafId == null) rafId = requestAnimationFrame(syncScrollbar);
        }
        thumbStrip.addEventListener('scroll', scheduleSync, { passive: true });
        window.addEventListener('resize', scheduleSync);
        scheduleSync();

        // Allow click+drag on the scrollbar track to scroll the strip
        var dragging = false;
        var dragStartX = 0;
        var dragStartScroll = 0;
        scrollbar.addEventListener('mousedown', function (e) {
          dragging = true;
          dragStartX = e.clientX;
          dragStartScroll = thumbStrip.scrollLeft;
          e.preventDefault();
        });
        window.addEventListener('mousemove', function (e) {
          if (!dragging) return;
          var trackWidth = scrollbar.clientWidth;
          var scrollWidth = thumbStrip.scrollWidth;
          var clientWidth = thumbStrip.clientWidth;
          var maxScroll = scrollWidth - clientWidth;
          if (maxScroll <= 0 || trackWidth <= 0) return;
          var deltaX = e.clientX - dragStartX;
          var scrollDelta = (deltaX / trackWidth) * scrollWidth;
          thumbStrip.scrollLeft = dragStartScroll + scrollDelta;
        });
        window.addEventListener('mouseup', function () { dragging = false; });
      }

      // ---------- Tier selection + per-tier pricing ----------
      var tiersWrap = section.querySelector('[data-pp-tiers]');
      var tiers = section.querySelectorAll('.pp-tier');
      var bars = section.querySelectorAll('[data-pp-bar]');
      var fromSubEl = section.querySelector('[data-pp-from-sub]');
      var fromOnceEl = section.querySelector('[data-pp-from-once]');
      var variantSelect = section.querySelector('[data-pp-variant]');
      var variantIdInput = section.querySelector('[data-pp-variant-id]');
      var quantityInput = section.querySelector('[data-pp-quantity-input]');
      var sellingPlanInput = section.querySelector('[data-pp-selling-plan-input]');
      var ctaPrice = section.querySelector('[data-pp-cta-price]');
      var ctaStrike = section.querySelector('[data-pp-cta-strike]');
      var stickyPrice = section.querySelector('[data-pp-sticky-price]');

      function currentVariantOption() {
        if (!variantSelect) return null;
        return variantSelect.options[variantSelect.selectedIndex];
      }

      function currentBasePrice() {
        var opt = currentVariantOption();
        if (opt) {
          var p = parseInt(opt.getAttribute('data-price'), 10);
          return isNaN(p) ? null : p;
        }
        // Fallback: use the data attribute on the section that Liquid wrote, if any.
        var liquidPrice = section.getAttribute('data-base-price');
        if (liquidPrice) {
          var lp = parseInt(liquidPrice, 10);
          if (!isNaN(lp)) return lp;
        }
        return null;
      }

      function selectedTier() {
        return section.querySelector('.pp-tier.is-selected');
      }

      function recomputeTierPrices() {
        var base = currentBasePrice();
        if (base == null) return;
        var cheapestByKind = { subscribe: null, once: null, bogo: null };
        tiers.forEach(function (tier) {
          var months = parseInt(tier.getAttribute('data-tier-months'), 10) || 1;
          var savePct = parseFloat(tier.getAttribute('data-tier-save-pct')) || 0;
          var kind = tier.getAttribute('data-tier-kind');
          var baseTotal = base * months;
          var nowTotal = Math.round(baseTotal * (1 - savePct / 100));
          var perUnit = Math.round(nowTotal / months);

          var strikeEl = tier.querySelector('[data-tier-strike]');
          var nowEl = tier.querySelector('[data-tier-now]');
          var perMonthEl = tier.querySelector('[data-tier-permonth]');
          var perEachEl = tier.querySelector('[data-tier-pereach]');

          if (strikeEl) strikeEl.textContent = money(baseTotal);
          if (nowEl) nowEl.textContent = money(nowTotal);
          if (perMonthEl) perMonthEl.textContent = money(perUnit) + '/month';
          if (perEachEl) perEachEl.textContent = money(perUnit) + '/each';

          if (cheapestByKind[kind] == null || nowTotal < cheapestByKind[kind]) {
            cheapestByKind[kind] = nowTotal;
          }
        });
        if (fromSubEl && cheapestByKind.subscribe != null) fromSubEl.textContent = money(cheapestByKind.subscribe);
        var cheapestOnce = cheapestByKind.once;
        if (cheapestByKind.bogo != null && (cheapestOnce == null || cheapestByKind.bogo < cheapestOnce)) {
          cheapestOnce = cheapestByKind.bogo;
        }
        if (fromOnceEl && cheapestOnce != null) fromOnceEl.textContent = money(cheapestOnce);
      }

      function activeBlock() {
        return tiersWrap ? (tiersWrap.getAttribute('data-active-block') || 'subscribe') : 'subscribe';
      }

      function selectDefaultTierForActiveBlock() {
        var kind = activeBlock();
        var pool = section.querySelectorAll('.pp-tier[data-tier-kind="' + kind + '"]');
        if (!pool.length) return;
        // Clear ALL tier selections (across both blocks)
        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        // Pick the first tier that was originally rendered with default state,
        // or fall back to the very first tier in this block.
        var defaultTier = null;
        pool.forEach(function (t) {
          if (defaultTier == null && t.hasAttribute('data-was-default')) defaultTier = t;
        });
        if (!defaultTier) defaultTier = pool[0];
        defaultTier.classList.add('is-selected');
        var input = defaultTier.querySelector('input[type="radio"]');
        if (input) input.checked = true;
      }

      // Mark which tier was Liquid-default so the per-block default can be restored.
      tiers.forEach(function (t) {
        if (t.classList.contains('is-selected')) t.setAttribute('data-was-default', '');
      });

      bars.forEach(function (bar) {
        bar.addEventListener('click', function () {
          if (!tiersWrap) return;
          var nextKind = bar.getAttribute('data-pp-bar');
          if (!nextKind) return;
          tiersWrap.setAttribute('data-active-block', nextKind);
          selectDefaultTierForActiveBlock();
          updateFormForTier();
          updateCta();
        });
      });

      function updateFormForTier() {
        var tier = selectedTier();
        if (!tier) return;
        var kind = tier.getAttribute('data-tier-kind');
        var months = parseInt(tier.getAttribute('data-tier-months'), 10) || 1;
        var planId = (tier.getAttribute('data-tier-selling-plan') || '').trim();

        if (kind === 'subscribe') {
          if (quantityInput) quantityInput.value = 1;
          if (sellingPlanInput) sellingPlanInput.value = planId || '';
        } else {
          if (quantityInput) quantityInput.value = months;
          if (sellingPlanInput) sellingPlanInput.value = '';
        }
      }

      function updateCta() {
        var tier = selectedTier();
        if (!tier) return;
        var base = currentBasePrice();
        if (base == null) return;
        var months = parseInt(tier.getAttribute('data-tier-months'), 10) || 1;
        var savePct = parseFloat(tier.getAttribute('data-tier-save-pct')) || 0;
        var baseTotal = base * months;
        var nowTotal = Math.round(baseTotal * (1 - savePct / 100));

        if (ctaPrice) ctaPrice.textContent = money(nowTotal);
        if (stickyPrice) stickyPrice.textContent = money(nowTotal);
        if (ctaStrike) {
          if (savePct > 0) {
            ctaStrike.textContent = money(baseTotal);
            ctaStrike.style.display = '';
          } else {
            ctaStrike.style.display = 'none';
          }
        }
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function (e) {
          if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
          tiers.forEach(function (t) { t.classList.remove('is-selected'); });
          tier.classList.add('is-selected');
          var input = tier.querySelector('input[type="radio"]');
          if (input) input.checked = true;
          updateFormForTier();
          updateCta();
        });
      });

      if (variantSelect) {
        variantSelect.addEventListener('change', function () {
          if (variantIdInput) variantIdInput.value = variantSelect.value;
          syncSwatches();
          recomputeTierPrices();
          updateCta();
        });
      }

      // ---------- Variant image swatches ----------
      var swatches = section.querySelectorAll('[data-pp-swatch]');

      function syncSwatches() {
        if (!swatches.length || !variantSelect) return;
        swatches.forEach(function (sw) {
          var on = sw.getAttribute('data-variant-id') === String(variantSelect.value);
          sw.classList.toggle('is-selected', on);
          sw.setAttribute('aria-checked', on ? 'true' : 'false');
        });
      }

      swatches.forEach(function (sw) {
        sw.addEventListener('click', function () {
          if (!variantSelect) return;
          if (sw.classList.contains('is-soldout')) return;
          variantSelect.value = sw.getAttribute('data-variant-id');
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      syncSwatches();

      // Initial sync on page load.
      updateFormForTier();
      updateCta();

      // ---------- Accordions ----------
      section.querySelectorAll('[data-pp-acc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var acc = btn.closest('.pp-acc');
          if (!acc) return;
          var open = acc.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });

      // ---------- Sticky mobile CTA mirror ----------
      var bar = section.querySelector('[data-pp-stickybar]');
      var stickyBtn = section.querySelector('[data-pp-sticky-cta]');
      var form = section.querySelector('form.pp__form') || section.querySelector('form');
      var sentinel = section.querySelector('[data-pp-cta]');

      function syncStickyBarVisibility() {
        if (!bar || !sentinel) return;
        var rect = sentinel.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0;
        bar.classList.toggle('is-visible', !inView);
      }

      if (bar && stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          var submit = (form || section).querySelector('[data-pp-cta]');
          if (submit) submit.click();
        });

        if (sentinel && 'IntersectionObserver' in window) {
          var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              bar.classList.toggle('is-visible', !entry.isIntersecting);
            });
          }, { rootMargin: '0px 0px -10% 0px', threshold: 0 });
          io.observe(sentinel);
        } else {
          window.addEventListener('scroll', syncStickyBarVisibility, { passive: true });
        }

        // Initial sync — don't wait for first IO callback or scroll event.
        syncStickyBarVisibility();
        window.addEventListener('resize', syncStickyBarVisibility);
      }

      // ----------------------------------------------------------------
      // Video testimonials sub-section — lightbox playback
      // ----------------------------------------------------------------
      (function () {
        var cards = section.querySelectorAll('[data-pp-vt-card]');
        if (!cards.length) return;

        var lightbox = section.querySelector('[data-pp-vt-lightbox]');
        var stage    = section.querySelector('[data-pp-vt-stage]');
        var closeEls = section.querySelectorAll('[data-pp-vt-close]');
        var toggleBtn= section.querySelector('[data-pp-vt-toggle]');
        var muteBtn  = section.querySelector('[data-pp-vt-mute]');
        if (!lightbox || !stage) return;

        function toEmbedUrl(raw) {
          if (!raw) return null;
          try {
            var u = new URL(raw);
            var host = u.hostname.replace(/^www\./, '');
            if (host === 'youtube.com' || host === 'm.youtube.com') {
              var id = u.searchParams.get('v');
              if (id) return 'https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0';
            }
            if (host === 'youtu.be') {
              var ytid = u.pathname.replace(/^\//, '');
              if (ytid) return 'https://www.youtube.com/embed/' + ytid + '?autoplay=1&rel=0';
            }
            if (host === 'vimeo.com') {
              var vid = u.pathname.replace(/^\//, '');
              if (vid) return 'https://player.vimeo.com/video/' + vid + '?autoplay=1';
            }
            if (host === 'player.vimeo.com') return raw + (raw.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1');
          } catch (e) {}
          return null;
        }

        var currentVideo = null;

        function openCard(card) {
          var src = card.getAttribute('data-video-src');
          var url = card.getAttribute('data-video-url');
          if (!src && !url) return;
          stage.innerHTML = '';

          if (src) {
            var v = document.createElement('video');
            v.src = src;
            v.autoplay = true;
            v.playsInline = true;
            v.setAttribute('playsinline', '');
            v.preload = 'auto';
            stage.appendChild(v);
            currentVideo = v;
            // Sync toggle/mute UI to actual video state
            v.addEventListener('play',  function () { toggleBtn && toggleBtn.classList.remove('is-paused'); });
            v.addEventListener('pause', function () { toggleBtn && toggleBtn.classList.add('is-paused'); });
            v.addEventListener('volumechange', function () {
              if (!muteBtn) return;
              muteBtn.classList.toggle('is-muted', v.muted);
            });
            // Default UI state
            if (toggleBtn) toggleBtn.classList.remove('is-paused');
            if (muteBtn)   muteBtn.classList.toggle('is-muted', v.muted);
            v.play().catch(function () {});
          } else {
            var embed = toEmbedUrl(url);
            if (embed) {
              var ifr = document.createElement('iframe');
              ifr.src = embed;
              ifr.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
              ifr.setAttribute('allowfullscreen', '');
              stage.appendChild(ifr);
              currentVideo = null; // iframes use their own controls
            } else {
              window.open(url, '_blank', 'noopener');
              return;
            }
          }

          lightbox.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        }

        function closeLightbox() {
          lightbox.hidden = true;
          stage.innerHTML = '';
          currentVideo = null;
          document.documentElement.style.overflow = '';
        }

        cards.forEach(function (c) {
          c.addEventListener('click', function (e) {
            e.preventDefault();
            openCard(c);
          });
        });
        closeEls.forEach(function (el) {
          el.addEventListener('click', function (e) { e.stopPropagation(); closeLightbox(); });
        });
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !lightbox.hidden) closeLightbox();
        });

        if (toggleBtn) {
          toggleBtn.addEventListener('click', function () {
            if (!currentVideo) return; // iframe path uses native controls
            if (currentVideo.paused) currentVideo.play(); else currentVideo.pause();
          });
        }
        if (muteBtn) {
          muteBtn.addEventListener('click', function () {
            if (!currentVideo) return;
            currentVideo.muted = !currentVideo.muted;
          });
        }
      })();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
